import { createUseStyles } from '@glu/theming';

const styles = ({ spacing: { unit } }) => ({
  root: {
    '& button': {
      float: 'right'
    },
    '& > p': {
      flex: 6,
      marginRight: unit * 2
    }
  },
  dismissBtn: {
    textTransform: 'uppercase'
  }
});

export default createUseStyles(styles);
